// extracted by mini-css-extract-plugin
export default {"blank":"Blank_blank__bB9RZ","blank--shadow":"Blank_blank--shadow__90rDE"};